import {Mapper} from '@s-ui/domain'

const DEFAULT_SIZE = 20

export class FromSearchToSearchVehiclesRequestValueObjectMapper extends Mapper {
  constructor({config, searchVehiclesRequestValueObject}) {
    super()
    this._searchVehiclesRequestValueObject = searchVehiclesRequestValueObject
    this._config = config
    this._defaultSearch = this._config.get('technicalDetails').DEFAULT_SEARCH
  }

  _cleanUndefinedProperties(object) {
    return JSON.parse(JSON.stringify(object))
  }

  _toArray = value => (value ? [value] : [])

  _getVehicles = ({search}) => [
    {
      makeId: search.makeId,
      modelId: search.model?.id,
      modelVersionId: search.modelVersionId,
      version: search.version
    }
  ]

  _getCategories = ({search}) => {
    const {category1Id, category2Id} = search

    const category1Ids = category1Id ? this._toArray(category1Id) : undefined
    const category2Ids = category2Id ? this._toArray(category2Id) : undefined

    const hasCategories = Boolean(category2Ids) || Boolean(category1Ids)

    if (!hasCategories) return

    return this._cleanUndefinedProperties({
      category1Ids,
      category2Ids
    })
  }

  _getDoors = ({doors}) => Array.isArray(doors) && doors[0]

  _getBodyTypeIds = ({bodyTypeIds}) => Array.isArray(bodyTypeIds) && bodyTypeIds[0]

  _getFuelTypeIds = ({fuelTypeIds}) => Array.isArray(fuelTypeIds) && fuelTypeIds[0]

  _getPagination = ({page}) => ({
    page,
    size: DEFAULT_SIZE
  })

  _getSort = ({sortBy, sortOrder}) => ({
    term: sortBy?.toLowerCase() || this._defaultSearch.sortBy,
    order: sortOrder?.toLowerCase() || this._defaultSearch.sortOrder
  })

  map = ({search}) => {
    const vehicles = this._getVehicles({search})
    const bodyTypeIds = this._getBodyTypeIds(search)
    const categories = this._getCategories({search})
    const doors = this._getDoors(search)
    const fuelTypeIds = this._getFuelTypeIds(search)
    const {hp, litres: cubicCapacity, price, year} = search

    return this._searchVehiclesRequestValueObject({
      filters: {
        ...(categories && {categories}),
        ...(vehicles && {vehicles}),
        ...(doors && {doors: [doors]}),
        ...(bodyTypeIds && {bodyTypeIds: [bodyTypeIds]}),
        ...(fuelTypeIds && {fuelTypeIds: [fuelTypeIds]}),
        ...(hp && (hp.from || hp.to) && {hp: {from: hp.from, to: hp.to}}),
        ...(cubicCapacity &&
          (cubicCapacity.from || cubicCapacity.to) && {
            cubicCapacity: {from: cubicCapacity.from, to: cubicCapacity.to}
          }),
        ...(price &&
          (price.from || price.to) && {
            price: {from: price.from, to: price.to}
          }),
        ...(year && (year.from || year.to) && {year: {from: year.from, to: year.to}})
      },
      pagination: this._getPagination(search),
      sort: this._getSort(search)
    })
  }
}
